import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.OceanCleanup;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "OceanCleanup.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "OceanCleanup.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "OceanCleanup.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/OceanCleanupGame/scenes/IntroductionScene.ts